class TWASideModalTrigger extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', () => {
      this.open(this.getAttribute('data-target'));
    });
  }

  open(target) {
    const modal = document.getElementById(target);
    if (modal) {
      modal.classList.add('twa-sidemodal-open');
      document.body.style.overflow = 'hidden';
    }
  }
}

customElements.define('twa-sidemodal-trigger', TWASideModalTrigger);


class TWASideModalContents extends HTMLElement {
  constructor() {
    super();

    const closeElements = this.querySelectorAll('.twa-sidemodal-overlay, .twa-sidemodal-close');
    closeElements.forEach(item => {
      item.addEventListener('click', () => {
        this.close(item.getAttribute('data-trigger-close'));
      });
    });
  }

  close(target) {
    const modal = document.getElementById(target);
    if (modal) {
      modal.classList.remove('twa-sidemodal-open');
      document.body.style.overflow = 'auto';
    }
  }
}

customElements.define('twa-sidemodal-contents', TWASideModalContents);